export class Eartefact {
    id: number;
    dateAt: Date;
    type: string;
    notes: string;
    content: string;
    name:string;
}
